import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { BusinessUnits } from "@/components/BusinessUnits";
import { About } from "@/components/About";
import { Industries } from "@/components/Industries";
import { WhyERA } from "@/components/WhyERA";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <BusinessUnits />
        <About />
        <Industries />
        <WhyERA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
